var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 21.7499C1.44281 21.7499 1.38506 21.7433 1.32787 21.7302C0.989437 21.6496 0.75 21.3477 0.75 20.9999C0.75 14.1847 1.61213 8.51653 12 8.25871V2.9999C12 2.70178 12.1764 2.43234 12.4491 2.3129C12.7207 2.19422 13.0393 2.24559 13.2591 2.44922L23.0091 11.4492C23.1628 11.5904 23.25 11.7905 23.25 11.9999C23.25 12.2093 23.1628 12.4094 23.0091 12.5508L13.2591 21.5508C13.0401 21.7544 12.7215 21.8071 12.4491 21.6871C12.1764 21.5675 12 21.298 12 20.9999V15.7587C4.87425 15.9293 3.5595 18.5581 2.17088 21.3353C2.04206 21.5939 1.779 21.7499 1.5 21.7499ZM12.75 14.2499C13.1646 14.2499 13.5 14.5853 13.5 14.9999V19.2867L21.3941 11.9999L13.5 4.71309V8.9999C13.5 9.41446 13.1646 9.7499 12.75 9.7499C4.46475 9.7499 2.68069 12.9543 2.32987 18.0725C3.88331 15.9858 6.531 14.2499 12.75 14.2499Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.9da617da9f6b964cefe7a307e66320c6.svg";
export { ForwardRef as ReactComponent };